import { render } from "./UsersFavouritesPage.vue?vue&type=template&id=fec97876"
import script from "./UsersFavouritesPage.vue?vue&type=script&lang=js"
export * from "./UsersFavouritesPage.vue?vue&type=script&lang=js"

import "./UsersFavouritesPage.vue?vue&type=style&index=0&id=fec97876&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__